const jobvacancies = [
    {
        "size": "",
        "style": "",
        "class": "",
        "children": [
            {
                "type": "topbar",
                "size": "12",
                "style": "",
                "class": "px-4",
                "title": 'Job Vacancies',
            },
            {
                "type": "tabs",
                "size": "12",
                "style": "",
                "class": "px-4 pt-4",
                "children": [
                    {
                        "title": "Content",
                        "service": "category",
                        "size": "",
                        "style": "",
                        "class": "flex",
                        "topbarControls": {
                            "addNewButton": false,
                            "activeToggle": false,
                            "deleteButton": false, 
                            "updateSuccessTitle": 'Category Updated!',
                            "updateSuccessMessage": 'Category Updated Successfully!',
                            "updateErrorTitle": 'Category Updation Failed!',
                            "updateErrorMessage": 'Please try again!',
                        },
                        "children": [
                            {
                                "type": "descriptionTab",
                                "size": "12",
                                "style": "",
                                "class": "p-0 d-flex",
                                "list": {
                                    "type": "list",
                                    "size": "4",
                                    "style": "",
                                    "class": "p-2",
                                    "empty": true,
                                    "children": [
                                    ]
                                },
                                "form": {
                                    "type": "form",
                                    "variant": "patch",
                                    "size": "8",
                                    "style": "margin-top: -4rem; border-left: 1px solid #DADCE3; min-height: calc(100vh - 144px)",
                                    "class": "pl-4 pt-3",
                                    "form": {
                                        "text": {
                                        "type": 'ckeditor',
                                        "label": 'Description',
                                        "placeholder": 'Enter Description',
                                        "required": false,
                                        "info": true,
                                        "character_count": 1000,
                                        "disabled": false,
                                        "class": '',
                                        "size": "12",
                                        "style": ""
                                        },
                                    },
                                    "children": [
                                    ]
                                }
                            },                            
                        ]
                    },
                    {
                        "title": "Jobs",
                        "service": "pages",
                        "size": "",
                        "style": "",
                        "class": "flex",
                        "topbarControls": {
                            "addNewButton": true,
                            "activeToggle": true,
                            "deleteButton": true, 
                            "addNewSuccessTitle": 'Vacancy Added!',
                            "addNewSuccessMessage": 'Vacancy Added Successfully!',
                            "addNewErrorTitle": 'Vacancy Creation Failed!',
                            "addNewErrorMessage": 'Please try again!',
                            "deleteSuccessTitle": 'Vacancy Deleted!',
                            "deleteSuccessMessage": 'Vacancy Deleted Successfully!',
                            "deleteErrorTitle": 'Vacancy Deletion Failed!',
                            "deleteErrorMessage": 'Please try again!',
                            "activeSuccessTitle": 'Vacancy Activated!',
                            "activeSuccessMessage": 'Vacancy Activated Successfully!',
                            "activeErrorTitle": 'Vacancy Activation Failed!',
                            "activeErrorMessage": 'Please try again!',
                            "updateSuccessTitle": 'Vacancy Updated!',
                            "updateSuccessMessage": 'Vacancy Updated Successfully!',
                            "updateErrorTitle": 'Vacancy Updation Failed!',
                            "updateErrorMessage": 'Please try again!',
                            "addNewModal": {
                                "title": "Add New Vacancy",
                                "submit_url": "/api/categories/$currentCategoryId/pages",
                                "variant": "add",
                                "form": {
                                    "title": {
                                        "type": 'text',
                                        "label": 'Vacancy Title',
                                        "placeholder": 'Enter Vacancy Title',
                                        "required": true,
                                        "info": true,
                                        "character_count": 250,
                                        "disabled": false,
                                        "class": '',
                                        "size": "12",
                                        "style": ""
                                    },
                                },
                                // "additionalProps": {
                                //     "date": "",
                                //     "featured": false,
                                //     // "slug": "",
                                //     "media_type":"Video",
                                //     "image_url":"",
                                //     "video_url":"",
                                //     // "upload_type": "",
                                //     // "upload_url": "",
                                // }
                            }
                        },
                        "children": [
                            {
                                "type": "jobVacanciesTab",
                                "size": "12",
                                "style": "",
                                "class": "p-0 d-flex",
                                "list": {
                                    "label": "Links",
                                    "type": "list",
                                    "info": true,
                                    "size": "4",
                                    "style": "border-right: 1px solid #DADCE3; min-height: calc(100vh - 144px)",
                                    "class": "p-0 pt-3 pr-3",
                                    "load_url": "/api/categories/$currentCategoryId/pages",
                                    "draggable": true,
                                    "children": [
                                    ]
                                },
                                "form": {
                                    "type": "form",
                                    "variant": "patch",
                                    "size": "8",
                                    "style": "margin-top: -4rem; border-left: 1px solid #DADCE3; min-height: calc(100vh - 144px)",
                                    "class": "pl-4 pt-3",
                                    "submit_url": "/api/pages/$currentPageId",
                                    "form": {
                                        "title": {
                                            "type": 'text',
                                            "label": 'Title',
                                            "placeholder": 'Enter Title',
                                            "required": true,
                                            "info": true,
                                            "character_count": 250,
                                            "disabled": false,
                                            "class": '',
                                            "size": "12",
                                            "style": ""
                                        },
                                        // "date": {
                                        //     "type": 'date',
                                        //     "label": 'Date',
                                        //     "placeholder": 'Enter Date',
                                        //     "required": true,
                                        //     "info": true,
                                        //     "character_count": 0,
                                        //     "disabled": false,
                                        //     "class": '',
                                        //     "size": "6",
                                        //     "style": ""
                                        // },
                                        // "featured": {
                                        //     "type": 'toggle',
                                        //     "label": 'Featured',
                                        //     "placeholder": 'Select Featured',
                                        //     "required": false,
                                        //     "info": true,
                                        //     "character_count": 0,
                                        //     "disabled": false,
                                        //     "class": '',
                                        //     "size": "6",
                                        //     "style": ""
                                        // },
                                        // "url": {
                                        //     "type": 'slug',
                                        //     "label": 'Path',
                                        //     "url": "/patientnews/$slug",
                                        //     "placeholder": 'Enter Path / Slug',
                                        //     "required": false,
                                        //     "info": true,
                                        //     "character_count": 50,
                                        //     "disabled": false,
                                        //     "class": '',
                                        //     "size": "12",
                                        //     "style": ""
                                        // },
                                        // "media_type": {
                                        //     "type": 'select',
                                        //     "label": 'Upload Options',
                                        //     "placeholder": 'Select Upload Option',
                                        //     "required": false,
                                        //     "info": true,
                                        //     "character_count": 0,
                                        //     "disabled": false,
                                        //     "class": '',
                                        //     "size": "6",
                                        //     "style": "",
                                        //     "options": ['Video']
                                        // },
                                        // "image_url": {
                                        //     "type": 'file',
                                        //     "label": 'Image Upload',
                                        //     "placeholder": 'Attach Image',
                                        //     "required": false,
                                        //     "info": true,
                                        //     "character_count": 0,
                                        //     "disabled": false,
                                        //     "class": '',
                                        //     "size": "6",
                                        //     "style": ""
                                        // },
                                        // "address": {
                                        //     "type": 'text',
                                        //     "label": 'Video URL',
                                        //     "placeholder": 'Enter Video URL',
                                        //     "required": false,
                                        //     "info": true,
                                        //     "character_count": 0,
                                        //     "disabled": false,
                                        //     "class": '',
                                        //     "size": "6",
                                        //     "style": ""
                                        // },
                                        "description": {
                                            "type": 'ckeditor',
                                            "label": 'Description',
                                            "placeholder": 'Enter Description',
                                            "required": false,
                                            "info": true,
                                            "character_count": 2000,
                                            "disabled": false,
                                            "class": '',
                                            "size": "12",
                                            "style": ""
                                            },
                                    },
                                    "children": [
                                    ]
                                }
                            }
                        ]
                    }
                ]
            },

        ]
    }
]

export { jobvacancies };